import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { DevScopeTicketListFilterSchema } from './-zod-schema';

// プロダクション詳細 > 開発スコープサブタブ。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx 側で
// 遅延ロードして bundle 分割する（他のタブ・ページと同じ規約）。
export const Route = createFileRoute('/_stacktrace/production/$productionId/_layout/dev-scope/')({
  validateSearch: zodValidator(DevScopeTicketListFilterSchema)
});